import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { createDemandeLicence, deleteDemandeLicence } from 'src/app/store/actions/demande-licence.action';
import { createLicence, deleteLicence } from 'src/app/store/actions/licence.action';
import { selectAllDemandeLicence } from 'src/app/store/selector/demande-licence.action';
import { selectAllInspections } from 'src/app/store/selector/inspection.selector';
import { selectAllLicence } from 'src/app/store/selector/licence.selector';
import { selectAllUserPerInspection } from 'src/app/store/selector/user-per-inspection.selector';

@Component({
  selector: 'app-licence-management',
  templateUrl: './licence-management.component.html',
  styleUrls: ['./licence-management.component.css']
})
export class LicenceManagementComponent implements OnInit {
  demandLicence$: Observable<any>;
  licences$: Observable<any>;
  inpections$: Observable<ReadonlyArray<any>>;
  usersPerInspection$: Observable<ReadonlyArray<any>>;
  // Données
  licences: any[] = [];
  filteredLicences: any[] = [];
  paginatedLicences: any[] = [];
  inspections: any[] = [];
  usersByInspection: any[] = []

  // Filtres
  searchTerm: string = '';
  statusFilter: string = 'TOUS';
  typeFilter: string = 'TOUS';

  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  startIndex: number = 0;
  endIndex: number = 0;
  totalPages: number = 0;
  visiblePages: number[] = [];

  // Modals
  showLicenceModal: boolean = false;
  showConfirmationModal: boolean = false;
  selectedLicence: any | null = null;

  licence: any = {
    utilisateur: {
      inspection: {
        nom: ''
      }
    }
  }

  // Statistiques
  activeLicencesCount: number = 0;

  constructor(private store: Store<any>, private http: HttpClient) {
    this.demandLicence$ = this.store.pipe(select(selectAllDemandeLicence))
    this.licences$ = this.store.pipe(select(selectAllLicence))
    this.inpections$ = this.store.pipe(select(selectAllInspections))
    this.usersPerInspection$ = this.store.pipe(select(selectAllUserPerInspection))
  }
  isSuper_admin = false;
  totalPagesLicences: number = 0
  currentPageLicences: number = 0
  totalItemsLicences: number = 0
  selectedPartenaire: number = -2
  paysArray: any[] = []
  licenceActiveCount: number = 0;
  demandeLicences: any[] = []
  ngOnInit() {

    this.loadLicences();
    this.loadUsersByInspections();
    this.demandLicence$.subscribe((demandeLicences: any) => {
      console.log('========= STORE UPDATE =========');
      console.log('Full state:', demandeLicences);
      console.log('demandeLicences:', demandeLicences.demandeLicences);

      if (demandeLicences.demandeLicences &&
        demandeLicences.demandeLicences.content &&
        Array.isArray(demandeLicences.demandeLicences.content)) {

        console.log('Content length:', demandeLicences.demandeLicences.content.length);
        console.log('Page info - Total pages:', demandeLicences.demandeLicences.totalPages);
        console.log('Page info - Current page (from pageable):', demandeLicences.demandeLicences.pageable?.pageNumber);
        console.log('First item ID:', demandeLicences.demandeLicences.content[0]?.id);

        this.demandeLicences = demandeLicences.demandeLicences.content

        this.totalPages = demandeLicences.demandeLicences.totalPages;
        this.totalItems = demandeLicences.demandeLicences.totalElements;
        this.currentPage = demandeLicences.demandeLicences.pageable.pageNumber + 1;

        console.log('Updated local variables:');
        console.log('- demandeLicences length:', this.demandeLicences.length);
        console.log('- currentPage:', this.currentPage);
        console.log('- totalPages:', this.totalPages);
      } else {
        console.log('No certificatControl found or still loading.');
        console.log('Structure:', demandeLicences.demandeLicences);
      }
      console.log('=================================');
    });

    this.licences$.subscribe((licences: any) => {
      console.log('========= STORE UPDATE =========');
      console.log('Full state:', licences);
      console.log('licences:', licences.licences);

      if (licences.licences &&
        licences.licences.content &&
        Array.isArray(licences.licences.content)) {

        console.log('Content length:', licences.licences.content.length);
        console.log('Page info - Total pages:', licences.licences.totalPages);
        console.log('Page info - Current page (from pageable):', licences.licences.pageable?.pageNumber);
        console.log('First item ID:', licences.licences.content[0]?.id);

        this.licences = licences.licences.content
        this.licenceActiveCount = this.licences.filter((l: any) => l.status === 'ACTIF').length
        this.totalPagesLicences = licences.licences.totalPages;
        this.totalItemsLicences = licences.licences.totalElements;
        this.currentPageLicences = licences.licences.pageable.pageNumber + 1;

        this.applyFilters();

        console.log('Updated local variables:');
        console.log('- demandeLicences length:', this.licences.length);
        console.log('- currentPage:', this.currentPage);
        console.log('- totalPages:', this.totalPages);
      } else {
        console.log('No certificatControl found or still loading.');
        console.log('Structure:', licences.licences);
      }
      console.log('=================================');
    });
    const userRole = localStorage.getItem("UserROle")!;
    this.isSuper_admin = userRole.toString() == "SUPER_ADMIN" ? true : false
    this.http.get<any[]>("https://restcountries.com/v3.1/all?fields=name,translations").pipe(
      map((data: any[]) =>
        data
          .map(country =>
            country.translations?.fra?.common || country.name?.common
          )
          .filter(Boolean)
          .sort((a: string, b: string) => a.localeCompare(b))
      )
    ).subscribe({
      next: (countries: string[]) => {
        console.log("🌍 Liste des pays :", countries);
        this.paysArray = countries;
      },
      error: (err) => {
        console.error("Erreur lors du chargement des pays :", err);
      }
    });

  }



  loadLicences() {
    // Appel à votre service pour charger les licences
    // this.licenceService.getLicences().subscribe(licences => {
    //   this.licences = licences;
    //   this.applyFilters();
    // });
  }

  loadUsersByInspections() {

    this.usersPerInspection$.subscribe((usersInspection: any) => {
      if (Array.isArray(usersInspection.usersInspection) && usersInspection.usersInspection.length > 0) {
        console.log(usersInspection)
        this.usersByInspection = usersInspection.usersInspection
      } else {
        console.log('No usersByInspection found or still loading.');
      }
    })
  }

  applyFilters() {
    let filtered = [...this.licences];

    // Filtre par recherche (numéro de licence)
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      filtered = filtered.filter(licence =>
        licence.numerolicence?.toLowerCase().includes(term) ||
        licence.partenaire?.nom?.toLowerCase().includes(term) ||
        licence.partenaire?.prenom?.toLowerCase().includes(term) ||
        licence.pays?.toLowerCase().includes(term)
      );
    }

    // Filtre par statut
    if (this.statusFilter !== 'TOUS') {
      filtered = filtered.filter(licence => licence.status === this.statusFilter);
    }

    // Filtre par type
    if (this.typeFilter !== 'TOUS') {
      filtered = filtered.filter(licence =>
        (this.typeFilter === 'PRO' && licence.isPro === true) ||
        (this.typeFilter === 'FREE' && licence.isFree === true)
      );
    }

    this.filteredLicences = filtered;
    this.totalItems = this.filteredLicences.length;
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.currentPage = 1;
    this.updatePaginatedLicences();
    this.updateStatistics();
  }

  updatePaginatedLicences() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedLicences = this.filteredLicences.slice(startIndex, endIndex);
    this.updateVisiblePages();
  }
  resetFilters() {
    this.searchTerm = '';
    this.statusFilter = 'TOUS';
    this.typeFilter = 'TOUS';
    this.applyFilters();
  }

  showcreateLicenceModal: boolean = false;
  updateStatistics() {
    this.activeLicencesCount = this.licences.filter(l => l.status === 'ACTIVE').length;
  }
  onpenCreateLicenceModal(licence?: any) {
    this.selectedLicence = { ...licence };
    console.log('Opening demande licence modal with licence:', licence);
    this.showcreateLicenceModal = true;
  }

  // Modal methods
  openLicenceModal(licence?: any) {

    if (licence) {
      this.licence = { ...licence };
      console.log('Opening licence modal with licence:', this.licence);
      this.selectedPartenaire = this.licence.partenaire.id;
      this.showLicenceModal = true;
    } else {
      this.showLicenceModal = true;
    }
  }

  closeLicenceModal() {
    this.showLicenceModal = false;
    this.selectedLicence = null;
    this.selectedPartenaire = -2;
    this.licence = {};
  }

  closeCreateLicenceModal() {
    this.showcreateLicenceModal = false;
    this.licence = {};
  }

  saveLicence() {
    if (!this.selectedLicence?.id) {
      this.licence = {
        ...this.licence,
        status: "ACTIF",
        partenaire: {
          id: +this.selectedPartenaire
        }
      }
      //console.log('Saving licence:', this.licence);
      this.store.dispatch(createLicence(this.licence));
    } else {
      this.licence = {
        ...this.licence,
      }
      //console.log('Saving licence:', this.licence);
      this.store.dispatch(createLicence(this.licence));
    }

    this.closeLicenceModal();
  }

  updateDemandeLicence() {
    this.store.dispatch(createDemandeLicence(this.selectedLicence));
    this.closeCreateLicenceModal();
  }

  viewLicenceDetails(licence: any) {
    this.licence = { ...licence };
    this.openLicenceModal(licence);
  }

  editLicence(licence: any) {
    this.licence = { ...licence };
    this.openLicenceModal(licence);
  }

  deleteLicence: boolean = false;
  toggleLicenceStatus(licence: any) {
    this.selectedLicence = licence;
    this.showConfirmationModal = true;
    this.deleteLicence = true;
  }

  toggleDemandeLicenceStatus(demandeLicence: any) {
    this.selectedLicence = demandeLicence;
    this.showConfirmationModal = true;
  }

  confirmToggleStatus() {
    if (this.selectedLicence) {
      //const newStatus = this.selectedLicence.status === 'INACTIVE' ? 'ACTIVE' : 'INACTIVE';
      if (this.deleteLicence) {
        this.store.dispatch(deleteLicence(this.selectedLicence.id))
        this.deleteLicence = false;
        this.showConfirmationModal = false;
      } else {
        this.store.dispatch(deleteDemandeLicence(this.selectedLicence.id))
        this.showConfirmationModal = false;
      }

    }
  }

  // Pagination methods

  updateVisiblePages() {
    const pages = [];
    const startPage = Math.max(1, this.currentPage - 2);
    const endPage = Math.min(this.totalPages, startPage + 4);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    this.visiblePages = pages;
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedLicences();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedLicences();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedLicences();
    }
  }

  // Helper methods
  getStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      'ACTIVE': 'Active',
      'EXPIRED': 'Expirée',
      'SUSPENDED': 'Suspendue',
      'INACTIVE': 'Inactive'
    };
    return statusMap[status] || status;
  }
}
